import { useCastersContext } from "@/pages/caster/caster-data-entry-v2/CastersContext";
import { useReadPLC } from "@/pages/caster/caster-data-entry-v2/hooks/useReadPLC";
import { ReadTrimDataFromPLC } from "@/pages/caster/repositories/ProductionRepository";
import { ResponseMESF } from "@dexteel/mesf-core";
import { IProbeRow } from "./useProbesTableData";

interface Props {
	refreshData: Function;
	setProbeSelected: Function;
	setModalMode: Function;
}

export const useProbeActions = ({
	refreshData,
	setProbeSelected,
	setModalMode,
}: Props) => {
	const { state, actions } = useCastersContext();
	const { readProbe } = useReadPLC();

	const onEditButtonClick = (row: IProbeRow) => {
		setProbeSelected(row);
		setModalMode("edit");
		actions.setRefreshInPause(true);
	};

	const onDeleteButtonClick = (row: IProbeRow) => {
		setProbeSelected(row);
		setModalMode("delete");
		actions.setRefreshInPause(true);
	};

	const onCreateButtonClick = () => {
		setProbeSelected(null);
		setModalMode("create");
		actions.setRefreshInPause(true);
	};

	const onDownloadButtonClick = (row: IProbeRow) => {
		actions.setRefreshInPause(true);
		if (row.id === "ladle") {
			readTrimFromPLC();
		}
		actions.setRefreshInPause(false);
	};
	const readTrimFromPLC = async () => {
		const ProcessId = state?.processData?.ProcessId;
		if (ProcessId) {
			const resp = await ReadTrimDataFromPLC({
				processId: ProcessId,
			});
			if (resp.ok) {
				await refreshData();
			} else {
				actions.setErrorMessage(resp.message);
			}
			return resp;
		} else {
			actions.setErrorMessage("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	const readProbesFromPLC = async () => {
		const processId = state?.processData?.ProcessId;
		if (processId) {
			await readProbe(processId);
			refreshData();
			return { ok: true } as ResponseMESF;
		} else {
			actions.setErrorMessage("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	return {
		onEditButtonClick,
		onDeleteButtonClick,
		onCreateButtonClick,
		onDownloadButtonClick,
		readProbesFromPLC,
	};
};
